<!-- Menus are wrapped in ng-template for lazy loading menu content -->
<!-- Prevents calls to UserService for rendering assignTo submenu -->

<!-- Menu trigger -->
<button mat-icon-button [matMenuTriggerFor]="elementOptionsMenu" [disabled]="disabled">
  <mat-icon>more_vert</mat-icon>
</button>

<!-- Main menu -->
<mat-menu #elementOptionsMenu="matMenu">
  <ng-template matMenuContent>

    <button mat-menu-item 
      *ngIf="config.edit" 
      (click)="edit(element)"
      [disabled]="!authService.canUpdate('element')">
      <mat-icon>mode_edit</mat-icon>
      {{ 'edit' | translate: 'plural' }}
    </button>

    <button mat-menu-item 
      *ngIf="config.editLegacy" 
      (click)="editLegacy(element)"
      [disabled]="!authService.canUpdate('element')">
      <mat-icon>mode_edit</mat-icon>
      {{ 'edit' | translate: 'plural' }}
    </button>

    <button mat-menu-item
      *ngIf="config.assignTo"
      [matMenuTriggerFor]="assignToSubmenu"
      [disabled]="!authService.canUpdate('element')">
      <mat-icon>record_voice_over</mat-icon>
      {{ 'assignto' | translate }}
    </button>

    <button mat-menu-item 
      *ngIf="config.setStatus"
      [matMenuTriggerFor]="editStatusSubmenu"
      [disabled]="!authService.canUpdate('element')">
      <mat-icon>label</mat-icon>
      {{ 'changestatus' | translate }}
    </button>

    <mat-divider
      *ngIf="(config.assignTo || config.edit || config.editLegacy || config.setStatus) && (config.delete || config.restore || config.showLogs)">
    </mat-divider>

    <button mat-menu-item
      *ngIf="config.showLogs"
      (click)="showLogs(element)"
      [disabled]="!authService.canRead('element')">
      <mat-icon>timeline</mat-icon>
      {{ 'commentandhistory' | translate }}
    </button>

    <mat-divider
      *ngIf="config.showLogs && (config.delete || config.restore || config.restoreArea || config.restoreAreaTemplate || config.restoreParagraph)">
    </mat-divider>

    <button mat-menu-item
      *ngIf="config.restoreArea"
      (click)="restoreArea(element)"
      [disabled]="!authService.canDelete('element')">
      <mat-icon>undo</mat-icon>
      {{ 'restore' | translate: 'plural' }}
    </button>

    <button mat-menu-item
      *ngIf="config.restoreAreaTemplate"
      (click)="restoreAreaTemplate(element)"
      [disabled]="!authService.canDelete('element')">
      <mat-icon>undo</mat-icon>
      {{ 'restore' | translate: 'plural' }}
    </button>

    <button mat-menu-item
      *ngIf="config.restoreParagraph"
      (click)="restoreParagraph(element)"
      [disabled]="!authService.canUpdate('element')">
      <mat-icon>undo</mat-icon>
      {{ 'restore' | translate: 'plural' }}
    </button>

    <button mat-menu-item
      *ngIf="config.delete"
      (click)="delete(element)"
      [disabled]="!authService.canDelete('element')">
      <mat-icon>delete</mat-icon>
      {{ 'delete' | translate: 'plural' }}
    </button>

  </ng-template>
</mat-menu>


<!-- Submenu: Edit status -->
<mat-menu #editStatusSubmenu="matMenu">
  <ng-template matMenuContent>
      <button mat-menu-item *ngFor="let statusType of statusTypes"
      (click)="setStatus(element, statusType._id)"
      [class.active]="element.status === statusType._id">
        <mat-icon [style.color]="statusType.color">label</mat-icon>
        {{ statusType.displayName }}
      </button>
  </ng-template>
</mat-menu>


<!-- Submenu: Assign to -->
<mat-menu #assignToSubmenu="matMenu">
  <ng-template matMenuContent>

    <button mat-menu-item (click)="assignToUser(element, -1)"
    [class.active]="element.assignedToUserId === -1" [style.paddingLeft]="'70px'">
      {{ 'notassigned' | translate }}
    </button>

    <button mat-menu-item *ngFor="let user of user$ | async"
    (click)="assignToUser(element, user._id)"
    [class.active]="element.assignedToUserId === user._id">
      <sg2-user-icon [user]="user"></sg2-user-icon>
      {{ user.fullName }}
    </button>

  </ng-template>
</mat-menu>
